// extracted by mini-css-extract-plugin
export default {"text":"zh9L0","activity":"MT+fG"};